import { render } from "./page12.vue?vue&type=template&id=f91b65fc&scoped=true"
import script from "./page12.vue?vue&type=script&lang=js"
export * from "./page12.vue?vue&type=script&lang=js"

import "./page12.vue?vue&type=style&index=0&id=f91b65fc&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91b65fc"]])

export default __exports__